import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import LoginWidget from '../../atoms/LoginWidget/LoginWidget';
import QuickLinksWidget from '../../atoms/QuickLinksWidget/QuickLinksWidget';
import TagsWidget from '../../atoms/TagsWidget/TagsWidget';

const Sidebar = ({
  children,
}) => {
  const { isLoggedIn } = useSelector(state => state.auth);
  return (
    <aside className="page-sidebar">
      {children}
      {!isLoggedIn && (
        <LoginWidget />
      )}
      <QuickLinksWidget />
      <TagsWidget />
    </aside>
  );
};

Sidebar.propTypes = {
  children: PropTypes.node,
};

Sidebar.defaultProps = {
  children: undefined,
};

export default Sidebar;
